const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_MOBILEOPERATORS':
      return initialState
    case 'FETCH_MOBILEOPERATORS_SUCCESS':
      return [...action.payload.data]
    case 'FETCH_MOBILEOPERATORS_FAIL':
      return initialState
    default:
      return state || initialState
  }
}



// WEBPACK FOOTER //
// ./src/features/SelectMobileOperator/reducer.js